/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteSendReqVo
 */
export interface NoteSendReqVo {
    /**
     * 接收者用户ID列表（与gradeId二选一）
     * @type {Array<number>}
     * @memberof NoteSendReqVo
     */
    receiverIds?: Array<number>;
    /**
     * 会员等级ID（与receiverIds二选一）
     * 0表示所有等级用户(1,2,3级)，其他值表示指定等级
     * 会员等级ID（与receiverIds二选一），0表示所有等级用户
     * @type {number}
     * @memberof NoteSendReqVo
     */
    gradeId?: number;
    /**
     * 模板ID（与title/content二选一，传templateId时使用模板的标题和内容）
     * @type {number}
     * @memberof NoteSendReqVo
     */
    templateId?: number;
    /**
     * 标题（不传templateId时必填）
     * @type {string}
     * @memberof NoteSendReqVo
     */
    title?: string;
    /**
     * 内容（不传templateId时必填）
     * @type {string}
     * @memberof NoteSendReqVo
     */
    content?: string;
    /**
     * 订单ID（可选）
     * @type {number}
     * @memberof NoteSendReqVo
     */
    orderId?: number;
    /**
     * 订单号（可选）
     * @type {string}
     * @memberof NoteSendReqVo
     */
    orderCode?: string;
    /**
     * 是否保存为模板：Y-保存，N-不保存
     * @type {string}
     * @memberof NoteSendReqVo
     */
    saveAsTemplate?: string;
}

/**
 * Check if a given object implements the NoteSendReqVo interface.
 */
export function instanceOfNoteSendReqVo(value: object): value is NoteSendReqVo {
    return true;
}

export function NoteSendReqVoFromJSON(json: any): NoteSendReqVo {
    return NoteSendReqVoFromJSONTyped(json, false);
}

export function NoteSendReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteSendReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'receiverIds': json['receiverIds'] == null ? undefined : json['receiverIds'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'saveAsTemplate': json['saveAsTemplate'] == null ? undefined : json['saveAsTemplate'],
    };
}

export function NoteSendReqVoToJSON(json: any): NoteSendReqVo {
    return NoteSendReqVoToJSONTyped(json, false);
}

export function NoteSendReqVoToJSONTyped(value?: NoteSendReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiverIds': value['receiverIds'],
        'gradeId': value['gradeId'],
        'templateId': value['templateId'],
        'title': value['title'],
        'content': value['content'],
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'saveAsTemplate': value['saveAsTemplate'],
    };
}

